<template>
  <div class="ai-assistant-container">
    <iframe
      v-if="iframeUrl"
      :src="iframeUrl"
      class="ai-assistant-iframe"
    />
    <div
      v-else
      class="ai-assistant-loading"
    >
      Загрузка...
    </div>
  </div>
</template>

<script>
import useCubus from '@/cubus/services/useCubus'
import { getAiAgentUrl, getConfig } from '@/libs/axios'

export default {
  name: 'CbsAiAssistant',
  data() {
    return {
      iframeUrl: null,
    }
  },
  mounted() {
    this.buildUrl()
  },
  methods: {
    buildUrl() {
      // PROP-086: токен из Vuex-сессии (в памяти), а не из localStorage. Уходит в AI-сервис на
      // другом origin (ai_agent_url) через URL — cookie туда не приложится, токен нужен явно.
      const session = useCubus.getSession()
      const token = (session && session.token) || ''
      if (!token) {
        this.$router.push({ name: 'auth-login' })
        return
      }

      let domainSid = ''
      if (session && session.domain) {
        domainSid = session.domain.sid
      }

      const baseUrl = getAiAgentUrl()
      if (!baseUrl) {
        // No AI agent URL configured
        return
      }

      const params = new URLSearchParams({
        token,
        api_url: getConfig(),
      })

      if (domainSid) {
        params.set('domain', domainSid)
      }

      this.iframeUrl = `${baseUrl}?${params.toString()}`
    },
  },
}
</script>

<style scoped>
.ai-assistant-container {
  height: calc(100vh - 120px);
  width: 100%;
}

.ai-assistant-iframe {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 6px;
}

.ai-assistant-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 18px;
  color: #666;
}
</style>
